import { css, Global } from "@emotion/react";
import ReactDOM from "react-dom/client";

import { App } from "./App";

ReactDOM.createRoot(document.getElementById("root") as Element).render(
  <>
    <Global
      styles={css`
        :root {
          font-family: "Roboto", Inter, Avenir, Helvetica, Arial, sans-serif;
          font-size: 9px;
          line-height: 16px;
          font-weight: 400;
        }
        
        .roboto-regular {
          font-family: "Roboto", sans-serif;
          font-weight: 400;
          font-style: normal;
        }

        .roboto-bold {
          font-family: "Roboto", sans-serif;
          font-weight: 700;
          font-style: normal;
        }
        body {
          margin: 20px 20px 20px 20px;
        }
      `}
    />
    <App />
  </>
);
